var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mwap_view"},[_c('div',{staticClass:"signup_body"},[_c('div',{staticClass:"upload-box"},[(_vm.item.imgurl)?_c('van-image',{staticClass:"video",attrs:{"src":_vm.item.imgurl}}):_vm._e(),_c('div',{staticClass:"input-box"},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.item.content))])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }